module.exports = __webpack_public_path__ + "img/uavPic1.32dd4a30.png";